import React from 'react';

const Vajak: React.FC = () => {
  return (
    <>
      <div className="max-w-3xl mx-auto py-12 px-4">
        <h1 className="text-3xl font-bold mb-4">🧠 Vajak Learning Space</h1>
        <p className="text-lg text-gray-700 mb-6">
          Welcome to the Vajak space! Here you can access special lessons, features, and resources dedicated to mastering Farsi vocabulary and culture.
        </p>
        {/* Add Vajak-specific content, lessons, or features here */}
      </div>
      {/* Blog-style Footer */}
      <footer className="bg-gray-900 text-white py-12 mt-12">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-purple-600 rounded-full flex items-center justify-center text-white font-bold mr-3">V</div>
                <h3 className="text-xl font-bold">Vajak</h3>
              </div>
              <p className="text-gray-400">The smartest way to learn Farsi, combining technology and human expertise for effective language acquisition.</p>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><a href="/" className="text-gray-400 hover:text-white transition">Home</a></li>
                <li><a href="/features" className="text-gray-400 hover:text-white transition">Features</a></li>
                <li><a href="/pricing" className="text-gray-400 hover:text-white transition">Pricing</a></li>
                <li><a href="/blog" className="text-gray-400 hover:text-white transition">Blog</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Support</h4>
              <ul className="space-y-2">
                <li><a href="/help" className="text-gray-400 hover:text-white transition">Help Center</a></li>
                <li><a href="/contact" className="text-gray-400 hover:text-white transition">Contact Us</a></li>
                <li><a href="/privacy" className="text-gray-400 hover:text-white transition">Privacy Policy</a></li>
                <li><a href="/terms" className="text-gray-400 hover:text-white transition">Terms of Service</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Connect With Us</h4>
              <div className="flex space-x-4 mb-4">
                <a href="https://facebook.com/vajakapp" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-purple-600 transition">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="https://twitter.com/vajakapp" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-blue-400 transition">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="https://instagram.com/vajakapp" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-pink-500 transition">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="https://youtube.com/vajakapp" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-red-600 transition">
                  <i className="fab fa-youtube"></i>
                </a>
              </div>
              <div className="flex items-center text-gray-400 text-sm">
                <i className="fas fa-envelope mr-2"></i> 
                <a href="mailto:support@pingquack.com" className="hover:text-white transition">support@pingquack.com</a>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>© 2024 پیروز Pirooz. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Vajak; 